<template>
  <div class="gp-svg-container" :class="{'b-d-active': active === 'vertical', 'a-c-active': active === 'horizontal'}">
    <svg class="gp-svg-content" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439.964 182.157">
      <g id="Group_5" data-name="Group 5" transform="translate(0 6.811)">
        <path
          id="Rectangle_11"
          data-name="Rectangle 11"
          class="cls-1"
          d="M58.934,0H328.4l58.934,138.272H0Z"
          transform="translate(26.836 6.279)"
        />
        <g id="Line_18" data-name="Line 18" class="cls-2" transform="translate(367.536 6.275)">
          <path class="cls-5" d="M1.271,0,66.347,138.705" />
          <path
            class="b-d-lines"
            d="M 68.17606353759766 138.7050323486328 L 64.51854705810547 138.7050323486328 L -3.030375239632122e-07 -6.543995709762385e-07 L 2.542062759399414 -6.543995709762385e-07 L 68.17606353759766 138.7050323486328 Z"
          />
        </g>
        <g id="Line_27" data-name="Line 27" class="cls-2" transform="translate(87.579 0.922)">
          <path class="cls-5" d="M.188.441H265.208" />
          <path
            class="a-c-lines"
            d="M 265.0203247070312 9.086136742553208e-06 L 265.3953552246094 0.8822698593139648 L -4.343106411397457e-05 0.8822698593139648 L 0.3762753009796143 9.086136742553208e-06 L 265.0203247070312 9.086136742553208e-06 Z"
          />
        </g>
        <g id="Line_22" data-name="Line 22" class="cls-2" transform="translate(4.633 6.275)">
          <path class="cls-5" d="M67.106,0,1.829,138.705" />
          <path
            class="b-d-lines"
            d="M 3.657543182373047 138.7050323486328 L 2.790462713164743e-05 138.7050323486328 L 65.83473968505859 -6.543995709762385e-07 L 68.37680053710938 -6.543995709762385e-07 L 3.657543182373047 138.7050323486328 Z"
          />
        </g>
        <g id="Line_16" data-name="Line 16" class="cls-2" transform="translate(21.579 154.565)">
          <path class="cls-5" d="M.422.984H396.751" />
          <path
            class="a-c-lines"
            d="M 396.332275390625 -3.791606286540627e-05 L 397.1710510253906 1.973090410232544 L -3.06256661133375e-05 1.973090410232544 L 0.8415854573249817 -3.791606286540627e-05 L 396.332275390625 -3.791606286540627e-05 Z"
          />
        </g>
        <g id="Line_25" data-name="Line 25" class="cls-2" transform="translate(351.219)">
          <path class="cls-5" d="M1.246,0,2.412,2.737" />
          <path
            class="a-c-lines"
            d="M 3.668580532073975 2.737274885177612 L 1.154965043067932 2.737274885177612 L 0.0001018785915221088 1.242290295522253e-06 L 2.491703987121582 1.242290295522253e-06 L 3.668580532073975 2.737274885177612 Z"
          />
        </g>
        <g id="Line_26" data-name="Line 26" class="cls-2" transform="translate(85.924)">
          <path class="cls-5" d="M2.424,0,1.257,2.737" />
          <path
            class="a-c-lines"
            d="M 2.513536691665649 2.737274885177612 L -7.870709669077769e-05 2.737274885177612 L 1.178481936454773 1.242290295522253e-06 L 3.670084476470947 1.242290295522253e-06 L 2.513536691665649 2.737274885177612 Z"
          />
        </g>
        <g id="Line_17" data-name="Line 17" class="cls-2" transform="translate(415.562 152.508)">
          <path class="cls-5" d="M1.859,0,4.466,6.122" />
          <path
            class="a-c-lines"
            d="M 6.350133895874023 6.12189769744873 L 2.582844495773315 6.12189769744873 L 1.181938841909869e-06 2.766292027445161e-06 L 3.718059301376343 2.766292027445161e-06 L 6.350133895874023 6.12189769744873 Z"
          />
        </g>
        <g id="Line_20" data-name="Line 20" class="cls-2" transform="translate(18.803 152.508)">
          <path class="cls-5" d="M4.495,0,1.884,6.122" />
          <path
            class="a-c-lines"
            d="M 3.767263412475586 6.12189769744873 L -2.604756264190655e-05 6.12189769744873 L 2.635817050933838 2.766292027445161e-06 L 6.353875160217285 2.766292027445161e-06 L 3.767263412475586 6.12189769744873 Z"
          />
        </g>
        <g id="Line_23" data-name="Line 23" class="cls-2" transform="translate(67.421 5.867)">
          <path class="cls-5" d="M.22.455H8.108" />
          <path
            class="b-d-lines"
            d="M 8.316901206970215 -2.592674354673363e-05 L 7.899336814880371 0.9105788469314575 L 8.346793833879929e-07 0.9105788469314575 L 0.4402856230735779 -2.592674354673363e-05 L 8.316901206970215 -2.592674354673363e-05 Z"
          />
        </g>
        <g id="Line_21" data-name="Line 21" class="cls-2" transform="translate(0 144.331)">
          <path class="cls-5" d="M.457.942H11.812" />
          <path
            class="b-d-lines"
            d="M 12.24371910095215 3.178329279762693e-05 L 11.37844371795654 1.886978268623352 L 6.787476013414562e-05 1.886978268623352 L 0.9124222993850708 3.178329279762693e-05 L 12.24371910095215 3.178329279762693e-05 Z"
          />
        </g>
        <g id="Line_24" data-name="Line 24" class="cls-2" transform="translate(364.547 5.867)">
          <path class="cls-5" d="M.208.455H8.1" />
          <path
            class="b-d-lines"
            d="M 7.87669849395752 -2.592674354673363e-05 L 8.314908981323242 0.9105788469314575 L 0.4155732095241547 0.9105788469314575 L 8.264779899036512e-05 -2.592674354673363e-05 L 7.87669849395752 -2.592674354673363e-05 Z"
          />
        </g>
        <g id="Line_19" data-name="Line 19" class="cls-2" transform="translate(427.725 144.331)">
          <path class="cls-5" d="M.43.942H11.784" />
          <path
            class="b-d-lines"
            d="M 11.33134269714355 3.178329279762693e-05 L 12.23939609527588 1.886978268623352 L 0.8610205054283142 1.886978268623352 L 4.531658851192333e-05 3.178329279762693e-05 L 11.33134269714355 3.178329279762693e-05 Z"
          />
        </g>
      </g>
      <path
        id="C"
        class="a-c-text"
        d="M9.276,3.949q-1.258.4-3.222.4-2.431,0-3.814-.542T.879,2.325Q.9,1.314,2.472.77,3.836.3,5.933.3q2.806,0,4.111.634.723.357.781.717H8.491q-.229-.277-.585-.418Q7.269.981,6.022.981q-1.27,0-2.006.353t-.745,1q-.007.653.77.979t1.984.327q1.235,0,1.883-.281.357-.151.592-.452h2.32Q10.523,3.549,9.276,3.949Z"
        transform="translate(213.888 0)"
      />
      <path
        id="B"
        class="b-d-text"
        d="M8.842,6.3H2.609L5.824.548H12.4q2.481.015,3.207.6.434.363.165.87-.277.524-1.075.843-.447.179-1.21.327.961.16,1.309.508t.085.847q-.272.515-1.1.925-.536.273-1.222.459-.776.214-1.719.293T8.842,6.3Zm1.32-2.556h-3.4L5.91,5.292H9.279q.9,0,1.46-.1,1.013-.189,1.3-.724.242-.451-.549-.619Q11.05,3.752,10.162,3.748Zm2.008-1.1q.629-.14.823-.5.214-.4-.454-.527-.588-.089-1.573-.089H7.981L7.286,2.8h3.346Q11.529,2.8,12.17,2.652Z"
        transform="translate(8.339 65.851)"
      />
      <path
        id="D"
        class="b-d-text"
        d="M10.833,6.3H4.908L1.859.548H7.693Q8.956.556,9.856.672q1.533.2,2.709.721.947.425,1.483.922t.791.95q.645,1.151,0,1.953Q13.949,6.3,10.833,6.3ZM10.6,2q-.91-.464-2.844-.464H5.136L7.154,5.292H9.8q2.028,0,2.362-.846.181-.463-.172-1.1Q11.5,2.469,10.6,2Z"
        transform="translate(414.306 65.851)"
      />
      <path
        id="A"
        class="a-c-text"
        d="M12.456,8.392H5.969L4.727,10.37H.865L7.238.9H11.33l6.28,9.472H13.6ZM11.425,6.746,9.243,3.031,6.972,6.746Z"
        transform="translate(210.097 168.945)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "RoofImage",
  props: ["active"]
};
</script>

<style>
.gp-svg-container {
  display: inline-block;
  position: relative;
  width: 100%;
  padding-bottom: 50%;
  vertical-align: middle;
  overflow: hidden;
}

.gp-svg-content {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
}

.cls-1 {
  fill: #555;
}

.cls-2 {
  fill: none;
}

.a-c-text {
  fill: #212529;
}

.a-c-lines {
  fill: #707070;
}

.a-c-active .a-c-text {
  fill: #029202;
}

.a-c-active .a-c-lines {
  fill: #029202;
}

.b-d-text {
  fill: #212529;
}

.b-d-lines {
  fill: #707070;
}

.b-d-active .b-d-text {
  fill: #029202;
}

.b-d-active .b-d-lines {
  fill: #029202;
}

.cls-5,
.b-d-lines,
.a-c-lines {
  stroke: none;
}
</style>
